import { object, string, boolean, number } from '@gogame/schemas';

import { ACTION_TYPE, SKIP, OPERATOR, VALUE, LIMIT } from './constants';

export const modifyActionSchema = object({
  [ACTION_TYPE]: string(),
  [SKIP]: boolean(),
  [OPERATOR]: number(),
  [VALUE]: number(),
  [LIMIT]: number(),
});
